export const ACCOUNT_REGISTRATION_FORM_TEST_IDS = {
  PHONE_INPUT: 'account-registration-phone-input',
  SUBMIT_BUTTON: 'account-registration-submit-button',
} as const
